module.exports = __webpack_public_path__ + "img/icon_teacher_satisfaction_q_hover.e1512969.svg";